import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import { Badge } from '../../../../shared/components/ui/Badge';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { Visitor } from '../../../../shared/services/visitors/visitorService';
import { formatDate } from '../../../../shared/utils/dateFormat';

interface VisitorTableProps {
  visitors: Visitor[];
  isLoading: boolean;
  onView: (visitor: Visitor) => void;
}

export function VisitorTable({ visitors, isLoading, onView }: VisitorTableProps) {
  const theme = useTheme();

  const columns = [
    { field: 'name', headerName: 'Nome', flex: 1 },
    { 
      field: 'document_number', 
      headerName: 'CPF', 
      width: 160,
      renderCell: (params: any) => (
        <Typography 
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'phone_number', 
      headerName: 'Telefone', 
      width: 150,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params: any) => (
        <Badge color={params.value.toUpperCase() === 'ACTIVE' ? 'success' : 'default'}>
          {params.value.toUpperCase() === 'ACTIVE' ? 'Ativo' : 'Inativo'}
        </Badge>
      )
    },
    { 
      field: 'tenant', 
      headerName: 'Empresa', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value?.name || 'Não informado'}
        </Typography>
      )
    },
    { 
      field: 'user', 
      headerName: 'Responsável', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value?.name || 'Não informado'}
        </Typography>
      )
    },
    { 
      field: 'startDate', 
      headerName: 'Data Início', 
      width: 120,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {formatDate(params.value)}
        </Typography>
      )
    },
    { 
      field: 'endDate', 
      headerName: 'Data Fim', 
      width: 120,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {formatDate(params.value)}
        </Typography>
      )
    },
  ];

  return (
    <DatabaseTable
      rows={visitors as any}
      columns={columns}
      loading={isLoading}
      onView={onView as any}
      hideDelete
      hideEdit
    />
  );
}